import { useUserFeatures } from "../contexts/UserFeaturesContext";

const useIsChartCardEnabled = (): boolean => {
  const { trends } = useUserFeatures();
  return Boolean(trends === "mx" || trends === "mx_master");
};

export default useIsChartCardEnabled;
